var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3v18h18V3z",
    fill: "#fff",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.104 13.505c-1.081 1.14-1.58 2.123-1.25 2.695.691 1.196 4.734.154 9.032-2.327 4.297-2.481 7.22-5.462 6.53-6.657-.366-.635-1.11-.64-2.902-.133",
    stroke: "#394259",
    strokeWidth: 1.625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.335 13.283a5.961 5.961 0 01-7.016 4.116c-.835.35-1.629.628-2.353.83a7.583 7.583 0 0011.24-6.612c-.04.035-.08.072-.117.11a18.699 18.699 0 01-1.754 1.556zM8.66 16.754a5.958 5.958 0 118.92-5.173c.292-.278.56-.545.803-.793.23-.233.435-.425.614-.592l.07-.065a7.583 7.583 0 10-12.4 7.193l.237-.073c.316-.096.669-.204 1.027-.297.234-.06.477-.126.73-.2z",
    fill: "#394259"
  })));
}
export default __webpack_public_path__ + "static/browser.3c2130bf.svg";
export { SvgBrowser as ReactComponent };